import React, { useContext } from "react"
import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Chip } from "@mui/material"
import BackIcon from "../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"
import { GlobalContext } from "../../contexts/GlobalContext"
import getIconComponent from "../utils/getIconComponent"
import GavelIcon from "@mui/icons-material/Gavel"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: { main: "#196C87" },
    secondary: { main: "#196C87" },
  },
})

const BandejaAprobacionIndex = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Aprobación de Solicitudes de Ingreso y Egreso</b>
        </div>

        <Box className={StyledRoot}>
          {/* GRILLA PRINCIPAL DE BANDEJA */}
          <CustomConditionalActionsTableServer
            endpoint="/AprobacionSolIngEgr/getSolicitudesPendientes"
            errorMsgFilterSearch="Error al cargar las solicitudes pendientes"
            queryKeyModal="BandejaSolicitudesPendientes"
            perPage={10}
            rowActionsWidthTable={120}
            rowActions={(row) => {
              // Buscamos la acción EDITAR (o PROCESAR si la llamaste así en tu BD)
              const editarAction = selectedMenuInfo?.data?.barraAcciones?.find(
                (action) => action?.acccaption === "EDITAR",
              )

              const actions = []

              if (editarAction) {
                actions.push({
                  label: "Editar",
                  key: "EDITAR",
                  icon: getIconComponent(editarAction?.accnameicono, editarAction?.acctipoico),
                  onClick: () => navigate("editar", { state: row.original }), // Pasa los datos a la vista Editar
                })
              }

              return actions
            }}
            topToolbarCustomActions={() => {
              // En una bandeja de aprobación transaccional usualmente no hay botón "Crear" ni "Importar"
              // Solo dejamos el espacio por si en el futuro agregas exportación.
              return []
            }}
            columnsTable={[
              {
                accessorKey: "solnumero",
                header: "Nº Solicitud",
                size: 160,
                Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
              },
              {
                accessorKey: "sgastatus",
                header: "Estado Solicitud",
                size: 160,
                Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
              },
              {
                accessorKey: "sgafecsol",
                header: "Fecha Solicitud",
                size: 130,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value ? normalFormatDate(value) : ""}</span>
                },
              },
              {
                accessorKey: "tsolInEg",
                header: "Naturaleza",
                size: 120,
                Cell: ({ cell }) => {
                  const valor = cell.getValue()
                  return (
                    <Chip
                      label={valor === "SOLING" ? "INGRESO" : valor === "SOLEGR" ? "EGRESO" : valor}
                      color={valor === "SOLING" ? "primary" : "secondary"}
                      size="small"
                    />
                  )
                },
              },
              {
                accessorKey: "tsoldescripcion",
                header: "Tipo de Solicitud",
                size: 250,
              },
              {
                accessorKey: "sgadescri",
                header: "Descripción de la Solicitud",
                size: 350,
              },
              {
                accessorKey: "sgaususol",
                header: "Generado Por",
                size: 120,
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default BandejaAprobacionIndex
